import {forwardRef} from 'react'
import useOutsideClick from './use_outside_click'

export const ClickOutsideManager = forwardRef(({onClick, opts}, ref) => {
	useOutsideClick(ref, onClick, opts)
	return null
})
